module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-tr.0f3aaf3e.mp4";